angular.module('autoremind.reports', ['autoremind.reports.todo'])
    .controller('autoremind.reports.ScreenController', [
    '$scope', 'reportConfig', '$routeParams', '$location', 'accountService',
    function ($scope, reportConfig, $routeParams, $location, accountService) {
        //$scope.reportsTypes = reportConfig.reportsType;
        $scope.reportTypes = [];
        console.log('accountService.currentUser', accountService.currentUser);
        $scope.checkIsEnabledCategory = function (category, param) {
            if (!angular.isDefined(accountService.currentUser.communication) || !angular.isDefined(accountService.currentUser.communication.categories)) {
                return true;
            }
            for (var i in accountService.currentUser.communication.categories) {
                var communicationCategory = accountService.currentUser.communication.categories[i];
                if (communicationCategory.communicationsCategoryId === category || communicationCategory.communicationsCategoryId === param) {
                    return communicationCategory.categoryEnabled;
                }
            }
            return true;
        };
        for (var i = 0; i < reportConfig.reportTypes.length; i++) {
            var reportType = reportConfig.reportTypes[i];
            if (reportType.permissions.length > 0 && reportType.isVisible) {
                if (!$scope.checkIsEnabledCategory(reportType.name, reportType.param)) {
                    continue;
                }
                var access = true;
                for (var j = 0; j < reportType.permissions.length; j++) {
                    var bool = reportType.permissions[j].bool;
                    if (bool !== undefined && 'OR' && (j < reportType.permissions.length + 1)) {
                        if (access) {
                            // Access already granted so skip checking more after OR
                            break;
                        }
                        // If OR and at least one more permission then ignore previous deny
                        access = true;
                        continue;
                    }
                    var permission = reportType.permissions[j];
                    if (permission.key !== undefined && accountService.hasUserPermission(permission.key)) {
                        //access = true;
                    }
                    else {
                        // If at least one permission is not present then deny access
                        access = false;
                    }
                }
                if (access) {
                    $scope.reportTypes.push(reportType);
                }
            }
        }
        $scope.report = false;
        $scope.currentReport = null;
        $scope.routeType = $routeParams.type;
        $scope.openReport = function (type, param) {
            $location.path('/reports/' + type);
            if (param) {
                $location.search('type', param);
            }
        };
        if (typeof $scope.routeType !== 'undefined') {
            //$scope.reportTypes.forEach(function(item) {
            reportConfig.reportTypes.forEach(function (item) {
                if (item.name === $scope.routeType) {
                    $scope.report = item.position;
                    $scope.currentReport = item;
                }
            });
        }
    }
]);
//# sourceMappingURL=reports.controllers.js.map